import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import "./assets/fonts/fonts.css";
import "./assets/styles/index.css";
import App from './App';
import './i18n/i18n';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // CRA forces NODE_ENV=production for every build, so demo & prod would look
  // identical in Sentry. Set REACT_APP_SENTRY_ENV per deploy to tell them apart.
  environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
  // Set at build time (e.g. to the git SHA) so errors group by deploy and
  // match the source maps uploaded via `npm run sentry:sourcemaps`.
  release: process.env.REACT_APP_SENTRY_RELEASE,
  // Only send events from production builds, not local dev.
  enabled: process.env.NODE_ENV === 'production',
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration()],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
